// extracted by mini-css-extract-plugin
module.exports = {"fields":"dd31006766--fields--IIZn1","controls":"dd31006766--controls--P9OjJ","info-block":"dd31006766--info-block--AHIqQ","image":"dd31006766--image--Y5YOP"};